export default {
  notAccomplishNum: 0
}
